<template>
  <div
    v-if="variants.v1 === variant"
    class="tw-flex tw-flex-col tw-gap-6 tw-px-4 tw-py-9"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded);`"
  >
    <h4>{{ vars.titleText }}</h4>

    <template v-if="vars.photoImage">
      <library-image :src="vars.photoImage" :design-width="423" :design-height="282" />
    </template>

    <template v-else-if="vars.videoUrl">
      <library-iframe :src="vars.videoUrl" class="tw-h-[282px] tw-w-full" />
    </template>

    <h5 v-if="vars.roleText">{{ vars.roleText }}</h5>

    <p v-if="vars.descriptionText">{{ vars.descriptionText }}</p>

    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-gap-4">
      <nuxt-link
        v-for="(button, index) in buttons"
        :external="true"
        :key="index"
        :class="`n-${button.type} n-btn tw-w-fit`"
        :to="button.link"
      >
        <div class="n-btn-container">
          <div class="n-btn-group">
            <div class="n-btn-t1">{{ button.label }}</div>
            <div class="n-btn-t2">{{ button.label }}</div>
          </div>
        </div>
      </nuxt-link>
    </div>
  </div>
  <div
    v-if="variants.v2 === variant"
    class="tw-flex tw-flex-col tw-gap-6 tw-px-4 tw-py-9"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded);`"
  >
    <h4>{{ vars.titleText }}</h4>

    <template v-if="vars.photoImage">
      <library-image :src="vars.photoImage" :h-ratio="1" :w-ratio="1" />
    </template>
    <template v-else-if="vars.videoUrl">
      <library-iframe :src="vars.videoUrl" class="tw-h-[282px] tw-w-full" />
    </template>

    <h5 v-if="vars.roleText">{{ vars.roleText }}</h5>

    <p v-if="vars.descriptionText">{{ vars.descriptionText }}</p>

    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-gap-4">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`card-btn-${index}`"
        :class="`n-${button.type} tw-w-fit`"
        :to="button.link"
        :external="true"
      >
        {{ button.label }}
      </nuxt-link>
    </div>
  </div>
  <div
    v-if="variants.v3 === variant"
    class="tw-flex tw-flex-col tw-gap-6 tw-px-4 tw-py-9"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded);`"
  >
    <h3>{{ vars.titleText }}</h3>

    <template v-if="vars.photoImage">
      <library-image :src="vars.photoImage" :h-ratio="1" :w-ratio="1" />
    </template>
    <template v-else-if="vars.videoUrl">
      <library-iframe :src="vars.videoUrl" class="tw-h-[282px] tw-w-full" />
    </template>

    <p v-if="vars.descriptionText">{{ vars.descriptionText }}</p>

    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-gap-4">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`card-btn-${index}`"
        :class="`n-${button.type} tw-w-fit`"
        :to="button.link"
        :external="true"
      >
        {{ button.label }}
      </nuxt-link>
    </div>
  </div>
  <div
    v-if="variants.v4 === variant"
    class="tw-flex tw-flex-col tw-border-2 tw-border-black tw-gap-6 tw-px-4 tw-py-9"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded);`"
  >
    <h3>{{ vars.titleText }}</h3>

    <template v-if="vars.photoImage">
      <library-image :src="vars.photoImage" :h-ratio="1" :w-ratio="1" />
    </template>
    <template v-else-if="vars.videoUrl">
      <library-iframe :src="vars.videoUrl" class="tw-h-[282px] tw-w-full" />
    </template>

    <nuxt-link
                  class="n-link tw-flex tw-flex-row tw-items-center tw-gap-2 tw-border-none"
                  :to="`tel:${vars.phoneText}`"
                >
                  <span>
                   <svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.17483 11.3332C1.60038 11.3332 1.10845 11.2025 0.699028 10.9412C0.289606 10.6798 0.085243 10.3661 0.0859393 9.99984V1.99984C0.0859393 1.63317 0.29065 1.31917 0.700073 1.05784C1.10949 0.796505 1.60108 0.666061 2.17483 0.666505H18.8859C19.4604 0.666505 19.9523 0.797172 20.3617 1.0585C20.7712 1.31984 20.9755 1.63362 20.9748 1.99984V9.99984C20.9748 10.3665 20.7701 10.6805 20.3607 10.9418C19.9513 11.2032 19.4597 11.3336 18.8859 11.3332H2.17483ZM10.5304 6.6665L18.8859 3.33317V1.99984L10.5304 5.33317L2.17483 1.99984V3.33317L10.5304 6.6665Z" fill="#18A24B"/>
</svg>

                  </span>
                  {{ vars.mailText }}
                </nuxt-link>
                <nuxt-link
                  :to="`mailto:${vars.mailText}`"
                  class="n-link tw-flex tw-flex-row tw-items-center tw-gap-2 tw-border-none"
                >
                  <span>
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.34 8.75333C10.52 8.75333 9.72667 8.62 8.98667 8.38C8.87074 8.3407 8.74608 8.33487 8.62699 8.36317C8.5079 8.39147 8.39919 8.45275 8.31333 8.54L7.26667 9.85333C5.38 8.95333 3.61333 7.25333 2.67333 5.3L3.97333 4.19333C4.15333 4.00667 4.20667 3.74667 4.13333 3.51333C3.88667 2.77333 3.76 1.98 3.76 1.16C3.76 0.8 3.46 0.5 3.1 0.5H0.793333C0.433333 0.5 0 0.66 0 1.16C0 7.35333 5.15333 12.5 11.34 12.5C11.8133 12.5 12 12.08 12 11.7133V9.41333C12 9.05333 11.7 8.75333 11.34 8.75333Z" fill="#18A24B"/>
</svg>

                  </span>
                  <span>{{ vars.phoneText }}</span>
                </nuxt-link>

    <p v-if="vars.descriptionText">{{ vars.descriptionText }}</p>

    <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-gap-4">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`card-btn-${index}`"
        :class="`n-${button.type} tw-w-fit`"
        :to="button.link"
        :external="true"
      >
        {{ button.label }}
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'MeetCard',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
